var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2123_3831)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.8796,
    y: 16.8965,
    width: 18.7204,
    height: 29.2038,
    transform: "rotate(3.41836 10.8796 16.8965)",
    fill: "#E8F8BC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.6728,
    cy: 37.1909,
    r: 10.4834,
    transform: "rotate(3.41836 36.6728 37.1909)",
    fill: "#B8E8EA"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2123_3831)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9692 42.644L19.4976 42.5561L19.7418 38.4683C19.8763 36.2155 18.151 34.2709 15.8982 34.1364C13.6453 34.0018 11.7008 35.7272 11.5662 37.98L11.322 42.0678L7.23423 41.8236L8.86206 14.5717L25.2132 15.5484L24.9691 19.6361C24.924 20.3901 25.4963 21.0351 26.2503 21.0801C27.0042 21.1252 27.6492 20.5529 27.6942 19.7989L27.9384 15.7111L29.301 15.7925C29.7734 15.8207 30.2241 15.6015 30.5023 15.217C30.7714 14.832 30.8285 14.334 30.6451 13.8946L27.7096 7.02778C27.0931 5.59615 25.7463 4.64052 24.1929 4.54773L21.7857 4.40394L21.867 3.04135C21.9121 2.28738 21.3398 1.64239 20.5858 1.59736C19.8319 1.55232 19.1869 2.12459 19.1418 2.87856L19.0605 4.24116L11.1937 3.77126C9.64037 3.67847 8.1808 4.45735 7.40686 5.81504L3.67476 12.2835C3.44033 12.698 3.42865 13.1987 3.65913 13.6136C3.88052 14.028 4.31099 14.2998 4.78335 14.328L6.14595 14.4094L4.51812 41.6614L3.14644 41.5794C2.39247 41.5344 1.74749 42.1067 1.70245 42.8606C1.65741 43.6146 2.22969 44.2596 2.98366 44.3046L20.8064 45.3692C21.5604 45.4143 22.2054 44.842 22.2504 44.088C22.2955 43.334 21.7232 42.6891 20.9692 42.644ZM9.76866 7.17772C10.0325 6.72854 10.5132 6.46553 11.0309 6.49645L24.012 7.27184C24.5297 7.30277 24.9847 7.62168 25.1842 8.09852L27.2473 12.9349L7.14446 11.7341L9.76866 7.17772ZM14.2914 38.1428C14.3364 37.3888 14.9814 36.8165 15.7354 36.8616C16.4894 36.9066 17.0616 37.5516 17.0166 38.3055L16.7724 42.3933L14.0472 42.2306L14.2914 38.1428Z",
    fill: "#194142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.136 28.4427C11.3821 28.3977 10.7371 28.97 10.692 29.7239C10.647 30.4779 11.2193 31.1229 11.9733 31.1679L18.2049 31.5401C18.9588 31.5852 19.6038 31.0129 19.6489 30.2589C19.6939 29.505 19.1216 28.86 18.3676 28.8149L12.136 28.4427Z",
    fill: "#194142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9183 24.9239C21.9633 24.1699 21.391 23.5249 20.6371 23.4799L12.4615 22.9915C11.7075 22.9465 11.0625 23.5188 11.0175 24.2728C10.9724 25.0267 11.5447 25.6717 12.2987 25.7167L20.4743 26.2051C21.2282 26.2501 21.8732 25.6779 21.9183 24.9239Z",
    fill: "#194142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9626 18.0292L12.787 17.5409C12.0331 17.4958 11.3881 18.0681 11.343 18.8221C11.298 19.576 11.8703 20.221 12.6243 20.2661L20.7998 20.7544C21.5538 20.7994 22.1988 20.2272 22.2438 19.4732C22.2889 18.7192 21.7166 18.0742 20.9626 18.0292Z",
    fill: "#194142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.426 21.5694C27.6675 21.1657 21.8338 26.3418 21.4301 33.1003C21.0264 39.8588 26.2024 45.6925 32.9609 46.0962C39.7194 46.4999 45.5531 41.3238 45.9568 34.5653C46.3605 27.8069 41.1845 21.9731 34.426 21.5694ZM33.1237 43.371C27.8641 43.0568 23.8411 38.5227 24.1553 33.2631C24.4694 28.0034 29.0036 23.9805 34.2632 24.2946C39.5228 24.6088 43.5458 29.1429 43.2316 34.4026C42.9175 39.6622 38.3833 43.6852 33.1237 43.371Z",
    fill: "#194142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0458 29.0831C38.5418 28.5151 37.6788 28.4636 37.1199 28.968L28.456 36.6553C27.888 37.1592 27.8365 38.0222 28.341 38.5811C28.5887 38.8602 28.9348 39.0177 29.28 39.0383C29.6252 39.0589 29.9876 38.9438 30.2668 38.6961L38.9307 31.0089C39.4987 30.5049 39.5502 29.642 39.0458 29.0831Z",
    fill: "#194142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7277 31.5439C30.8565 31.6113 31.8263 30.7509 31.8937 29.6221C31.9611 28.4932 31.1007 27.5235 29.9719 27.4561C28.8431 27.3886 27.8733 28.2491 27.8059 29.3779C27.7385 30.5067 28.5989 31.4764 29.7277 31.5439Z",
    fill: "#194142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4148 40.2079C38.5436 40.2754 39.5134 39.4149 39.5808 38.2861C39.6482 37.1573 38.7878 36.1876 37.659 36.1201C36.5302 36.0527 35.5605 36.9131 35.493 38.0419C35.4256 39.1708 36.286 40.1405 37.4148 40.2079Z",
    fill: "#194142"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2123_3831"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2123_3831"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.6808,
    height: 43.6808,
    fill: "white",
    transform: "translate(4.22546 0.620605) rotate(3.41836)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.a0736e32027fa8b0a3988dde7a7ca435.svg";
export { ForwardRef as ReactComponent };